import { usePathname } from "next/navigation";

import { DRAFT_PREFIX } from "./draft-route";

const INTERNAL_PREFIX = new RegExp(`^(?:${DRAFT_PREFIX})?/(ie|uk)(?=/|$)`);

export function toPublicPathname(pathname: string): string {
  const match = pathname.match(INTERNAL_PREFIX);
  if (!match) return pathname;
  const rest = pathname.slice(match[0].length) || "/";
  if (match[1] === "uk") return rest === "/" ? "/uk/" : `/uk${rest}`;
  return rest;
}

export function usePublicPathname(): string {
  return toPublicPathname(usePathname() ?? "/");
}
